module.exports = __webpack_public_path__ + "img/like_tobe_here2.420f74d4.png";